module.exports = __webpack_public_path__ + "static/img/1_2_2.2684e9d9.png";